<app-horizontal-wrapper
  [type]="type"
  [label]="label"
  [alignRight]="alignRight"
  [required]="required() && !isReadOnly"
  [col3]="col3"
  [noCols]="noCols"
  [contentPadding]="isReadOnly"
  [marginBottom]="!inTable && !isReadOnly"
>
  <div class="row">
    <div class="{{ col3 ? 'col-lg-5' : 'col-lg-12 d-flex align-items-center' }} ">
      @if (isReadOnly) {
        <div>
          <div
            *ngIf="
              type != 'date' &&
              type != 'email' &&
              type != 'amount' &&
              type != 'percent' &&
              type != 'phone' &&
              type != 'website'
            "
          >
            {{ control.value }}
          </div>
          <div *ngIf="type == 'date'">
            {{ formatDate(control.value) }}
          </div>

          <div *ngIf="type == 'amount'">
            <i class="fa-solid fa-euro text-secondary px-2"></i>
            {{ formatCurrency(control.value, decimals) }}
          </div>
          <div *ngIf="type == 'percent'">{{ control.value }}%</div>
          <div *ngIf="type == 'email'" class="d-flex justify-content-between">
            <div>
              {{ control.value }}
            </div>
            <div>
              <a [href]="'mailto:' + control.value" tabindex="-1">
                <i class="fa-solid fa-envelope text-secondary ms-2"></i>
              </a>
            </div>
          </div>
          <div *ngIf="type == 'phone'" class="d-flex justify-content-between">
            <div>
              {{ control.value }}
            </div>
            <div>
              <a [href]="'tel:' + control.value" tabindex="-1">
                <i class="fa-solid fa-phone text-secondary ms-2"></i>
              </a>
            </div>
          </div>
          <div *ngIf="type == 'website'" class="d-flex justify-content-between">
            <div>
              {{ control.value }}
            </div>
            <div>
              <a [href]="control.value" target="_blank" tabindex="-1">
                <i class="fa-solid fa-link text-secondary"></i>
              </a>
            </div>
          </div>
        </div>
      } @else {
        <div class="input-group">
          <!--PREFIXES-->
          @if (addPrefix) {
            <span
              *ngIf="type === 'amount'"
              class="input-group-text {{ control.disabled ? 'disabled-group' : '' }}"
            >
              <i class="fa-solid fa-euro text-secondary"></i>
            </span>
            <span *ngIf="type == 'website'" class="input-group-text">https://</span>
          }

          <!--INPUT FIELDS-->
          <ng-container *ngIf="type === 'textarea'">
            <textarea
              [id]="id"
              type="text"
              class="form-control textarea-md"
              [placeholder]="placeholder"
              [formControl]="control"
              (blur)="onBlur()"
              [rows]="textareaRows"
            ></textarea>
          </ng-container>

          <!--Type action???--->
          <ng-container
            *ngIf="
              type === 'color' ||
              type === 'website' ||
              type === 'facebook' ||
              type === 'instagram' ||
              type === 'twitter' ||
              type === 'phone' ||
              type === 'address' ||
              type === 'text' ||
              type === 'iban' ||
              type === 'action' ||
              type === 'delete'
            "
          >
            <!--TODO: can this be simplified to one input? -->
            <input
              *ngIf="!typeahead || typeahead.length == 0"
              [id]="id"
              type="text"
              [class]="'form-control' + (inTable ? ' py-1 px-2' : '')"
              [placeholder]="placeholder"
              [formControl]="control"
              (blur)="onBlur()"
            />
            <input
              *ngIf="typeahead && typeahead.length > 0"
              [id]="id"
              type="text"
              [class]="'form-control' + (inTable ? ' form-control-inline py-1 px-2 text-sm' : '')"
              [placeholder]="placeholder"
              [formControl]="control"
              [ngbTypeahead]="search"
              (blur)="onBlur()"
            />
          </ng-container>

          <ng-container *ngIf="type === 'password'">
            <input
              [id]="id"
              [type]="showPassword ? 'text' : 'password'"
              [class]="'form-control password-input' + (inTable ? ' py-1 px-2' : '')"
              [placeholder]="placeholder"
              [formControl]="control"
              (blur)="onBlur()"
            />
            <span
              class="input-group-text {{ control.disabled ? 'disabled-group' : '' }}"
            >
              <a
                (click)="togglePasswordVisibility()"
                tabindex="-1"
                [title]="showPassword ? 'Wachtwoord verbergen' : 'Wachtwoord tonen'"
              >
                <i
                  class="fa-solid text-secondary"
                  [ngClass]="showPassword ? 'fa-eye-slash' : 'fa-eye'"
                ></i>
              </a>
            </span>
          </ng-container>

          <ng-container *ngIf="type === 'date'">
            <input
              [id]="id"
              type="date"
              [class]="'form-control' + (inTable ? ' py-1 px-2' : '')"
              [placeholder]="placeholder"
              [formControl]="control"
              (blur)="onBlur()"
            />
          </ng-container>

          <ng-container *ngIf="type == 'email'">
            <div class="position-relative email col-lg-12">
              <p-chips
                [inputId]="id"
                class="flex-fill"
                [formControl]="emailControl"
                [separator]="';'"
                [addOnBlur]="true"
                [inputStyle]="
                  control.value && control.disabled ? { display: 'none' } : { display: 'block' }
                "
              >
              </p-chips>
              <div style="position: absolute; z-index: 99; right: 0.75rem; top: 0.375rem; display: flex; gap: 0.5rem;">
                <a
                  *ngIf="showCopy && control.value"
                  (click)="copyToClipboard()"
                  tabindex="-1"
                  title="Kopieer naar klembord"
                >
                  <i class="fa-solid" [ngClass]="copied ? 'fa-check text-success' : 'fa-copy text-secondary'"></i>
                </a>
                <a
                  [href]="'mailto:' + control.value"
                  tabindex="-1"
                >
                  <i class="fa-solid fa-envelope text-secondary"></i>
                </a>
              </div>
            </div>
          </ng-container>

          <ng-container *ngIf="type === 'vatnumber'">
            <input
              [id]="id"
              type="text"
              [class]="'form-control' + (inTable ? ' py-1 px-2' : '')"
              [placeholder]="placeholder"
              [formControl]="control"
              (blur)="onBlur()"
            />
          </ng-container>
          <ng-container *ngIf="type === 'enterprisenumber'">
            <input
              [id]="id"
              type="text"
              [class]="'form-control' + (inTable ? ' py-1 px-2' : '')"
              [placeholder]="placeholder"
              [formControl]="control"
              mask="0000.000.000"
              (blur)="onBlur()"
            />
          </ng-container>
          <ng-container *ngIf="type === 'amount' || type === 'percent' || type === 'number'">
            <input
              [id]="id"
              type="number"
              [class]="
                'form-control' +
                (inTable ? ' py-0 px-0' : '') +
                (contentAlignRight ? ' text-end' : '')
              "
              [placeholder]="placeholder"
              [formControl]="control"
              [min]="addMinValidator ? 0 : null"
              (blur)="onBlur()"
            />
          </ng-container>

          <!--SUFFIXES-->
          <ng-container>
            <span
              *ngIf="type === 'percent'"
              class="input-group-text {{ control.disabled ? 'disabled-group' : '' }}"
            >
              <div class="input-group-text">
                <i class="fa-solid fa-percent text-secondary"></i>
              </div>
            </span>
            <span
              *ngIf="type === 'color'"
              class="input-group-text {{ control.disabled ? 'disabled-group' : '' }}"
            >
              <ngx-colors ngx-colors-trigger [formControl]="control"></ngx-colors>
            </span>
            <span *ngIf="type === 'enterprisenumber'" class="input-group-text">
              <a
                (click)="control.updateValueAndValidity({ emitEvent: true })"
                tabindex="-1"
              >
                <i class="fa-solid fa-search text-secondary me-2"></i>
              </a>
              <a
                href="https://help.assistonline.eu/article/212-wat-is-een-ondernemingsnummer-en-hoe-kan-ik-dit-opzoeken-voor-mijn-vzw"
                target="_blank"
              >
                <i class="fa-solid fa-circle-info text-primary ms-1"></i>
              </a>
            </span>
            <span *ngIf="type === 'vatnumber'" class="input-group-text">
              <a
                *ngIf="control && control.value && !isOrganisation"
                (click)="control.updateValueAndValidity({ emitEvent: true })"
                tabindex="-1"
              >
                <i class="fa-solid fa-search text-secondary me-2"></i>
              </a>
            </span>
            <ng-container *ngIf="control && control.value">
              <div
                *ngIf="type == 'phone'"
                class="input-group-text {{ control.disabled ? 'disabled-group' : '' }}"
              >
                <a [href]="'tel:' + control.value" tabindex="-1">
                  <i class="fa-solid fa-phone text-secondary"></i>
                </a>
              </div>
              <!--<div *ngIf="type == 'email'" class="input-group">
        <a [href]="'mailto:' + control.value" tabindex="-1">
          <i class="fa-solid fa-envelope text-secondary"></i>
        </a>
      </div>-->
              <div
                *ngIf="type == 'website'"
                class="input-group-text {{ control.disabled ? 'disabled-group' : '' }}"
              >
                <a [href]="'https://' + control.value" target="_blank" tabindex="-1">
                  <i class="fa-solid fa-link text-secondary"></i>
                </a>
              </div>
              <div
                *ngIf="type == 'facebook'"
                class="input-group-text {{ control.disabled ? 'disabled-group' : '' }}"
              >
                <a href="www.facebook.com" target="_blank" tabindex="-1">
                  <i class="fa-brands fa-facebook text-secondary"></i>
                </a>
              </div>
              <div
                *ngIf="type == 'instagram'"
                class="input-group-text {{ control.disabled ? 'disabled-group' : '' }}"
              >
                <a href="www.instagram.com" target="_blank" tabindex="-1">
                  <i class="fa-brands fa-instagram text-secondary"></i>
                </a>
              </div>
              <div
                *ngIf="type == 'twitter'"
                class="input-group-text {{ control.disabled ? 'disabled-group' : '' }}"
              >
                <a href="www.twitter.com" target="_blank" tabindex="-1">
                  <i class="fa-brands fa-twitter text-secondary"></i>
                </a>
              </div>
              <div
                *ngIf="type == 'delete'"
                class="input-group-text {{ control.disabled ? 'disabled-group' : '' }}"
              >
                <a (click)="delete()" [title]="label + ' verwijderen'" tabindex="-1">
                  <i class="fa-solid fa-trash-can text-secondary"></i>
                </a>
              </div>
              <div
                *ngIf="type == 'address' && href"
                class="input-group-text {{ control.disabled ? 'disabled-group' : '' }}"
              >
                <a [href]="href" target="_blank" title="Bekijk op Google Maps" tabindex="-1">
                  <i class="fa-solid fa-map-location-dot text-secondary"></i>
                </a>
              </div>
              <div
                *ngIf="showCopy && type != 'email'"
                class="input-group-text {{ control.disabled ? 'disabled-group' : '' }}"
              >
                <a (click)="copyToClipboard()" tabindex="-1" title="Kopieer naar klembord">
                  <i class="fa-solid" [ngClass]="copied ? 'fa-check text-success' : 'fa-copy text-secondary'"></i>
                </a>
              </div>
            </ng-container>
            <ng-container *ngIf="type == 'action' || iconClass">
              <div class="input-group-text">
                <a (click)="doAction()" tabindex="-1" [title]="actionTitle">
                  <i class="fa-solid text-secondary" [class]="iconClass"></i>
                </a>
              </div>
            </ng-container>
            <ng-container *ngIf="isLoading" class="input-group-text">
              <i class="fa-solid text-secondary fa-spinner-third fa-spin"></i>
            </ng-container>
            <span
              *ngIf="modal"
              class="input-group-text {{ control.disabled ? 'disabled-group' : '' }}"
            >
              <a (click)="open(content)">
                <i class="fa-solid fa-circle-info text-primary"></i>
              </a>
            </span>
          </ng-container>
        </div>
        @if (!col3) {
          <ng-container *ngTemplateOutlet="suffix" />
        }
      }
    </div>
    @if (col3) {
      <div class="col-lg-7 ps-0 d-flex align-items-center">
        <ng-container *ngTemplateOutlet="suffix" />
      </div>
    }
    <app-validator [control]="control" [label]="label"></app-validator>
  </div>
</app-horizontal-wrapper>

<ng-template #content let-modal>
  <app-modal [activeModalInput]="modal">
    <ng-container modal-title>{{ modalTitle }}</ng-container>
    <ng-container modal-body><ng-content></ng-content></ng-container>
    <ng-container modal-footer>
      <app-button (click)="modal.close(null)">Venster sluiten</app-button>
    </ng-container>
  </app-modal>
</ng-template>

<ng-template #suffix>
  <ng-content select="[custom-suffix]"></ng-content>
</ng-template>
